module.exports = __webpack_public_path__ + "static/img/else.38159498.png";